module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n  Sliders Page\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-607c124c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ui-elements/Sliders.vue
// module id = 518
// module chunks = 1